import { cn } from '@folio/lib';
import { useKorintUniqConfig } from 'korint-sdk/react';

interface LogoModuleProps {
  className?: string;
}

export function LogoModule({ className }: LogoModuleProps) {
  const { title, logoPath } = useKorintUniqConfig();

  return <img src={logoPath} alt={`${title} Logo`} className={cn('h-10', className)} />;
}
